import React from 'react';

const ExplorerHeader = ({ eyebrow, title, accent, description }) => (
  <header className="explorer-header">

    <h1 className="explorer-heading">
      {title}{' '}
    </h1>
    <p className="explorer-description">{description}</p>
  </header>
);

export default ExplorerHeader;
